export const SEARCH_PREFIX           = 'SEARCH_';
export const SEARCH_PAGE_SIZE = 12;

export const EXPERIMENT_SEARCH_ONLY_FIELDS = ['name', 'created', 'status', 'type', 'user.name', 'id', 'company'];


